<template>
    <el-container direction="vertical">
        <el-row class="expense-production-header">
            <el-col :xs="24" :sm="24" :md="24" :lg="16">
                <div class="expense-production-subtitle">
                    ID {{ expense.id }} (создан {{ expense.created_by_name }} {{ expense.created_at }})
                </div>
                <div class="expense-production-title">
                    Создать расходы на производство
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" class="actions">
                <template>
                    <template v-if="isEdit">
                        <span class="action-title action-edit" @click="save">
                            Сохранить
                        </span>
                    </template>
                    <template v-else>
                        <span class="action-title action-edit">
                            Редактировать
                        </span>
                    </template>
                </template>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <div class="expense-production-main">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="5" class="print-custom-width-1">
                    <el-row>
                        <el-col :span="9" class="gray">
                            Дата расхода
                        </el-col>
                        <el-col :span="15">
                            <el-date-picker
                                v-model="expense.date"
                                type="date"
                                placeholder="дд.мм.гггг"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                size="mini"
                                class="w100"
                            />
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            Касса
                        </el-col>
                        <el-col :span="15">
                            <el-select
                                v-model="expense.office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            &nbsp;
                        </el-col>
                        <el-col :span="15">
                            <el-select
                                v-model="expense.pay_type_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            Сумма, руб
                        </el-col>
                        <el-col :span="15">
                            <auto-numeric
                                v-model="expense.amount"
                                :options="[numericOptions, numericOptionsNegative]"
                                class="autonumeric"
                            />
                            <div class="field-error bold" v-if="errors.amount" v-text="errors.amount[0]"></div>
                            <div v-else-if="!isExpenseAmountEqDealExpenseAmount && deals.length" class="field-error bold">
                                {{ amountErrorMessage }}
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="11" class="print-custom-width-2">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Статья
                        </el-col>
                        <el-col :span="14">
                            {{ getExpenseType }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получил - тип
                        </el-col>
                        <el-col :span="14">
                            {{ receivedByType }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получил
                        </el-col>
                        <el-col :span="14">
                            <el-select
                                v-model="expense.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                collapse-tags
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdListForFilter" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Сумма на производстве, руб
                        </el-col>
                        <el-col :span="14">
                            {{ expense.factory_sum !== 0 ? formatFinance(expense.factory_sum) : 0 }}
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8" class="print-custom-width-3">
                    <el-row>
                        <el-col class="gray pt10">
                            Комментарий
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <template v-if="isEdit">
                                <el-input
                                    size="mini"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="expense.comment"
                                />
                                <div class="error" v-if="errors.comment">
                                    {{ errors.comment[0] }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-format-text="expense.comment">
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <template>
            <div class="expense-production-deals" v-show="isDealsVisible">
                <div class="expense-production-deals-grid" v-loading="loadingDeals">
                    <template v-for="(column, index) in dealsColumns">
                        <div :key="'header_' + index" class="header-cell">
                            {{ column.headerName }}
                        </div>
                    </template>
                    <template v-for="(deal, dealIndex) in deals">
                        <template v-for="(column, columnIndex) in dealsColumns">
                            <div
                                :key="dealIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="column.field === 'contract' || column.field === 'address' ? deal[column.field] : false"
                            >
                                <template v-if="column.field === 'debt_paid'">
                                    <el-checkbox v-model="deal[column.field]" @change="handleDebtPaid(deal)" />
                                </template>
                                <template v-else-if="column.field === 'id'">
                                    <a :href="getDealLink(deal[column.field])" target="_blank" class="link">
                                        {{ deal[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="['expense_sum', 'received_by_delivery'].indexOf(column.field) !== -1">
                                    {{ formatFinance(deal[column.field]) }}
                                </template>
                                <template v-else-if="column.field === 'sum'">
                                    <div>{{ deal[column.field]['production_cost'] ? formatFinance(deal[column.field]['production_cost']) : '-' }}</div>
                                    <div>{{ deal[column.field]['expense_sum_production'] ? formatFinance(deal[column.field]['expense_sum_production']) : '-' }}</div>
                                </template>
                                <template v-else>
                                    {{ deal[column.field] }}
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
                <div
                    class="expenses-total expenses-total-grid"
                    v-if="deals.length"
                >
                    <div
                        :class="[
                            'grid-cell',
                            { 'green bold': isExpenseAmountEqDealExpenseAmount },
                            { 'red bold': !isExpenseAmountEqDealExpenseAmount }
                        ]"
                    >
                        Сумма к перечислению: {{ formatFinance(expensesTotalAmount) }} руб.
                    </div>
                    <div class="grid-cell">
                        &nbsp;
                    </div>
                    <div class="grid-cell">
                        &nbsp;
                    </div>
                    <div class="grid-cell">
                        <template v-if="expensesToPayAmount">
                            {{ formatFinance(expensesToPayAmount) }} руб.
                        </template>
                    </div>
                    <div class="grid-cell">
                        &nbsp;
                    </div>
                    <div class="grid-cell">
                        &nbsp;
                    </div>
                </div>
            </div>
        </template>
    </el-container>
</template>
<script>
import ExpenseMixin from '@/mixins/expense';
import moment from 'moment';
import '@/assets/styles/card.scss';
import '@/assets/styles/expenses-production.scss?1';
import { pickerOptions } from '@/common/pickerOptions';
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/print.scss?1';
import localReferences from '@/helpers/localReferences';

const initialExpensesProduction = {
    id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    created_by_name: '',
    report_date: '',
    office_id: '',
    pay_type_id: '',
    source_type: localReferences.expenseSource.cash,
    amount: '',
    recipient_id: '',
    recipient_type: 'factory',
    date: moment().format('DD.MM.YYYY'),
    comment: '',
    expense_type: 'production',
    factory_sum: 0
};

export default {
    name: 'ExpensesProductionBaseGrid',
    mixins: [
        ExpenseMixin
    ],
    data() {
        return {
            expense: { ...initialExpensesProduction },
            errors: [],
            deals: [],
            dealsList: [],
            contactDebt: null,
            contactDeal: null,
            loadingMain: false,
            loadingDeals: false,
            numericMinimumValue: '-9999999999999',
            isEdit: 1,
            formLabelWidth: '120px',
            pickerOptions,
            selectedRowsCount: 0,
            dealsColumns: [
                { headerName: 'Id сделки', field: 'id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата запуска в производство', field: 'start_production_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор № от', field: 'contract', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text' },
                { headerName: 'м2', field: 'square_m2', fieldClass: 'grid-cell' },
                { headerName: 'Сумма в производство', field: 'sum', fieldClass: 'grid-cell' },
                { headerName: 'Получено доставкой', field: 'received_by_delivery', fieldClass: 'grid-cell' },
                { headerName: 'Долг погашен', field: 'debt_paid', fieldClass: 'grid-cell' },
                { headerName: 'Отправить со счёта производству', field: 'expense_sum', fieldClass: 'grid-cell' }
            ],
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            amountErrorMessage: 'Сумма расхода по сделкам не совпадает с суммой к перечислению'
        };
    },
    methods: {
        formatFinance,
        handlePositionClick(position) {
            position.isOpened = !position.isOpened;
        },
        async getDeals(recipientId) {
            this.loadingDeals = true;
            try {
                this.deals = [];
                this.deals = await this.$store.dispatch('expenses/getDealsProduction', { recipient_id: recipientId });
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loadingDeals = false;
            }
        },
        async getFactorySum() {
            if (this.expense.recipient_id === '') return 0;
            try {
                this.expense.factory_sum = await this.$store.dispatch('expenses/getFactorySum', { factory_id: this.expense.recipient_id });
            } catch (error) {
                console.log(error.message);
            }
        },
        save() {
            if (!this.expense.amount || !parseInt(this.expensesTotalAmount, 10)) {
                return;
            }
            if (this.isSaveButtonPressed) {
                return;
            }
            this.isSaveButtonPressed = true;
            if (this.deals.length) {
                if (this.isExpenseAmountEqDealExpenseAmount) {
                    this.createDealProductionExpenses();
                } else {
                    this.errors = { amount: [this.amountErrorMessage] };
                    this.$message({
                        showClose: true,
                        message: this.amountErrorMessage,
                        type: 'error',
                        duration: 5000,
                        customClass: this.alertClass()
                    });
                    this.isSaveButtonPressed = false;
                }
            }
        },
        async createDealProductionExpenses() {
            const expenses = this.deals.filter(deal => deal.debt_paid === true).map(deal => {
                const sum = deal.sum.production_cost - deal.sum.expense_sum_production;
                return {
                    date: this.expense.date,
                    created_by_id: this.$store.state.auth.employerId,
                    office_id: this.expense.office_id,
                    pay_type_id: this.expense.pay_type_id,
                    recipient_type: this.expense.recipient_type,
                    recipient_id: this.expense.recipient_id,
                    source_type: localReferences.expenseSource.cash,
                    deal_id: deal.id,
                    amount: sum,
                    comment: this.expense.comment,
                    expense_detail: [{
                        expense_type: this.expense.expense_type,
                        amount: sum
                    }]
                };
            });

            this.loadingDeals = true;
            try {
                const response = await this.$store.dispatch('expenses/createDealProductionExpenses', { expenses });
                const totalAmount = response.data.data.meta.totalAmount;
                const expensesCount = response.data.data.data.length;

                if (totalAmount) {
                    this.showMessage(`Создано ${expensesCount} операций расход на сумму ${totalAmount} руб.`);
                }
                this.expense.amount = 0;
                this.getDeals(this.expense.recipient_id);
            } catch (e) {
                console.log(e.message);
            } finally {
                this.getFactorySum();
                this.loadingDeals = false;
                this.isSaveButtonPressed = false;
            }
        },
        close() {
            this.$router.go(-1);
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
        },
        handleDebtPaid(deal) {
            deal.expense_sum = deal.debt_paid ? deal.sum.production_cost - deal.sum.expense_sum_production - deal.received_by_delivery : 0;
        },
        dealHandler() {
            this.deals = [];
            if (this.expense.recipient_id) {
                this.getDeals(this.expense.recipient_id);
            }
        },
        expense_sum() {
            return this.deal.expense_sum;
        },
        showMessage(message) {
            this.$notify({ title: 'Успешно', message, type: 'success' });
        },
        getNumericOptionsForDeal(deal) {
            return {
                readOnly: deal.debt_paid,
                maximumValue: (deal.sum.production_cost > 0 || deal.sum.expense_sum_production > 0) ? deal.sum.production_cost - deal.sum.expense_sum_production : 9999999,
                minimumValue: 0
            };
        }
    },
    beforeMount() {
        this.expense.recipient_type = 'factory';
        this.expense.recipient_id = 1;
    },
    computed: {
        /*production_sum: {
            get() {
                return this.$store.state.deals.current.installer_balance;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installer_balance', value });
            }
        },*/
        receivedByIdListForFilter() {
            return this.factoriesList;
        },
        pagesInfo() {
            return this.$store.state.deals.pages;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        isDealsVisible() {
            return this.expense.recipient_id;
        },
        expensesTotalAmount() {
            return this.deals.reduce((sum, deal) => sum + +deal.expense_sum, 0);
        },
        expensesToPayAmount() {
            return this.deals.reduce((sum, deal) => sum + +deal.expense_sum, 0);
        },
        isExpenseAmountEqDealExpenseAmount() {
            if (this.deals.length && +this.expensesTotalAmount) {
                return this.expense.amount === +this.expensesTotalAmount;
            }
            return true;
        },
        recipient_id() {
            return this.expense.recipient_id;
        },
        receivedByType() {
            return this.getNameFromListById(this.receivedFromTypesList, this.expense.recipient_type);
        },
        getExpenseType() {
            return this.getNameFromListById(this.expenseTypeList, this.expense.expense_type);
        },
        amount() {
            return this.expense.amount;
        }
    },
    watch: {
        recipient_id() {
            this.dealHandler();
            this.getFactorySum();
        }
    }
};
</script>
